//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: section.querySelector(".productVisualSwiperNext"),
            prevEl: section.querySelector(".productVisualSwiperPrev"),
        },
        pagination: {
            el: '.productVisualSwiperPagination'
        },
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update active variant on input changes
    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /************
     Product Info Expand
     ************/
    section.querySelectorAll(".productInfo.expand").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");

            element.querySelector(".productInfoText").classList.toggle("active");
            element.querySelector(".productInfoTextFull").classList.toggle("active");
        });
    })


    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // variables to check if elements exist
        let productATCExists = section.querySelector(".productATC") || false;
        let sellingPlanExists = section.querySelector(".productSelling") || false;

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        section.querySelector(".productATCPriceReal").textContent = price(activeVariant.price * quantity);
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelector(".productATCPriceReal").classList.add("sale");
            section.querySelector(".productATCPriceCompare").textContent = price(activeVariant.compare_at_price * quantity);
            section.querySelector(".productATCPriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
        } else {
            section.querySelector(".productATCPriceReal").classList.remove("sale");
            section.querySelector(".productATCPriceCompare").textContent = "";
            section.querySelector(".productATCPriceSavings").textContent = "";
        }

        /**************
         Selling Plan
         ***************/

        if (sellingPlanExists) {
            let activeVariantPlan = activeVariant.selling_plan_allocations[0];

            // find the correct selling_plan_allocation
            for (let plan of activeVariant.selling_plan_allocations) {
                if (plan.selling_plan_id === parseInt(section.querySelector('.productSellingLabelBodyBottomWrapContentSelect').value)) {
                    activeVariantPlan = plan;
                }
            }

            // save parent elements
            const once = section.querySelector(".productSellingLabelBody.once");
            const sub = section.querySelector(".productSellingLabelBody.sub");

            // update price outside of selling plan module if selling plan is selected
            if (section.querySelector(".productSellingLabelInput:checked")?.value === "sub") {
                section.querySelector(".productATCPriceReal").textContent = price(activeVariantPlan.price * quantity);
                section.querySelector(".productATCPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity);
                section.querySelector(".productATCPriceSavings").textContent = `Save ${Math.round((activeVariantPlan.compare_at_price - activeVariantPlan.price) * 100 / activeVariantPlan.compare_at_price)}%`;
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            section.querySelector(".productATCLabel").textContent = "Add To Bag";
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCLabel").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();


    /**************
     Product ATC
     ***************/
    section.querySelector('.productATC').addEventListener("click", async function () {

        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productSellingLabelInput.sub')?.checked) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingLabelBodyBottomWrapContentSelect').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });
});
